import { ArrowUpRight } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import { ui } from "@/data/translations";

export default function Header({ content, language, setLanguage }) {
  const text = ui[language];
  return (
    <header className="site-header" data-testid="header-navbar">
      <div className="header-inner">
        <a className="brand-link" href="#top" data-testid="header-brand-link" aria-label={content.business_name}>
          <BrandLogo src={content.logo_url} testId="header-logo" />
          <span className="brand-wordmark">Vincent<span>GC</span></span>
        </a>
        <nav className="header-nav" aria-label="Primary navigation">
          <a href="#services" data-testid="nav-services-link">{text.navServices}</a>
          <a href="#approach" data-testid="nav-approach-link">{text.navApproach}</a>
          <a href="#work" data-testid="nav-work-link">{text.navWork}</a>
          <a href="#estimate" data-testid="nav-estimate-link">{text.navEstimate}</a>
        </nav>
        <div className="header-actions">
          <button className="language-toggle" type="button" onClick={() => setLanguage(language === "en" ? "es" : "en")} data-testid="language-toggle-button" aria-label="Change language">
            <span className={language === "en" ? "active" : ""}>EN</span><i>/</i><span className={language === "es" ? "active" : ""}>ES</span>
          </button>
          <a className="owner-link" href="/admin" data-testid="owner-login-link">{text.ownerAccess}<ArrowUpRight size={14} /></a>
        </div>
      </div>
    </header>
  );
}
